module.exports = __webpack_public_path__ + "static/media/pipaltree.ec95997a.png";